import { Injectable } from '@angular/core';
import { LocaleService } from '@next/core-lib/i18n';
import { SeriesOptionsType } from 'highcharts';

import {
  BaseChartConfig,
  IconMapType,
  toUTCDateMs,
} from 'src/app/shared/components/disease-insight-chart/base-chart.config';
import { DiseaseChartDay } from 'src/app/shared/components/disease-insight-chart/models';

@Injectable()
export class VirusMonitorChartConfig extends BaseChartConfig {
  getRightAxisTitle(_localeService?: LocaleService): string {
    return `mm`;
  }

  getInfectionRiskLabel(localeService: LocaleService): string {
    return localeService.translate('virusMonitor.riskChart.riskLevel');
  }

  getIsHourlyData(): boolean {
    return true;
  }

  override buildAdditionalSeries(localeService: LocaleService, days: DiseaseChartDay[]): SeriesOptionsType[] {
    const virusSprayThreshold = this.getVirusSprayThreshold(days);
    const leafRollVirusRiskPercentage = this.getLeafRollVirusRiskPercentage(days);

    return [
      {
        id: 'leafRollVirusRiskPercentage',
        type: 'spline',
        name: localeService.translate('virusMonitor.riskChart.liceNumberLeafroll'),
        data: leafRollVirusRiskPercentage,
        tooltip: {
          valueSuffix: '%',
        },
        color: '#b37feb',
        custom: { isHourly: false },
      },
      {
        id: 'virusSprayThreshold',
        type: 'spline',
        name: localeService.translate('virusMonitor.virusDetails.sprayThreshold'),
        data: virusSprayThreshold,
        tooltip: {
          valueSuffix: '%',
        },
        color: '#7d7d7d',
        dashStyle: 'Dash',
        custom: { isHourly: false },
      },
    ];
  }

  override getLegendIconMap(): IconMapType {
    return {
      ...super.getLegendIconMap(),
      leafRollVirusRiskPercentage: { iconPath: 'virus_leaf_roll_aphid.svg', color: '#b37feb' },
    };
  }

  override getHiddenLegendIds(): string[] {
    return ['emergenceDate', 'virusSprayThreshold'];
  }

  private getVirusSprayThreshold(days: DiseaseChartDay[]): [number, number | undefined][] {
    return days.map((day) => {
      const date = new Date(day.date);
      const dateTime = toUTCDateMs(date, 12);
      return [dateTime, day.sprayThreshold];
    });
  }

  private getLeafRollVirusRiskPercentage(days: DiseaseChartDay[]): [number, number | undefined][] {
    return days.map((day) => {
      const date = new Date(day.date);
      const dateTime = toUTCDateMs(date, 12);
      const leafRollVirusRiskPercentage = day.leafRollVirusRiskPercentage === 0
        ? 0
        : Number.parseFloat(day.leafRollVirusRiskPercentage.toFixed(1));

      return [dateTime, leafRollVirusRiskPercentage];
    });
  }
}
